export const OfficeAbstractState = {
	url: '/office',
	abstract: true,
	redirectTo: 'office.dashboard', // default child
	template:
		'<office-abstract-page flags-capabilities="$resolve.flagsCapabilitiesAccess"></office-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		return import(
			/* webpackChunkName: "officeAbstractPageMod" */
			'@Containers/office-abstract-page/office-abstract-page.cmp.js'
		)
			.then(res =>
				$ocLazyLoad.load({name: res.default}).catch(err => {
					throw err;
				})
			)
			.catch(err => {
				throw err;
			});
	},
	resolve: {
		/** @ngInject */
		isAdmin: ($q, AuthSvc) => {
			const _def = $q.defer();
			const isLogged = AuthSvc.isLoggedIn();
			if (isLogged) {
				_def.resolve('is logged in');
			} else {
				_def.reject('is not logged in');
			}
			return _def.promise;
		},
		/** @ngInject */
		flagsCapabilities: (RoutesResolveSvc, $state) =>
			RoutesResolveSvc.getFlagsCapabilitiesLogAccess({fromState: 'office'}).catch(() =>
				$state.go('user.auth')
			),
	},
};
